import { Authority } from './Authority'

export class UserProperty {
  userId: string = ''
  userName: string = ''
  branchCode: string = ''
  organizationCode?: string
  authority: Authority = Authority.None
  locale?: UserLocaleProperty
  lastLogin?: UserLoginProperty
  supplier?: SupplierProperty

  hasAuthority(...authorities: Authority[]): boolean {
    return authorities.includes(this.authority)
  }
}

export class UserLocaleProperty {
  name: string = ''
  timeZone: string = ''
}

export class UserLoginProperty {
  date: string = ''
}

export class SupplierProperty {
  supplierCode: string = ''
  branchCode: string = ''
  buildingDisclose: boolean = false
  ownershipFactories: FactoryProperty[] = []
}

export class FactoryProperty {
  factoryCode: string = ''
  expenseCode: string = ''
}
